export default __webpack_public_path__ + "static/media/RemolqueDoble VIP8.20765556.png";